const lbAgentChatWidget = angular.module('app.lbAgentChatWidget', []);

lbAgentChatWidget.controller('lbAgentChatWidgetCtrl', require('./lbAgentChatWidgetCtrl'));
lbAgentChatWidget.directive('lbAgentChatWidget', require('./lbAgentChatWidgetDir'));

export default lbAgentChatWidget;



// WEBPACK FOOTER //
// ./src/components/lbAgentChatWidget/index.js